import { HAS_WINDOW } from './constants';

const _getStorage = (useSession = false) =>
  useSession ? window.sessionStorage : window.localStorage;

export const setStorageValue = (
  key: string,
  value: any,
  useSession = false,
) => {
  if (!HAS_WINDOW) return;

  const storage = _getStorage(useSession);

  storage.setItem(key, JSON.stringify(value));
};

export const getStorageValue = (key: string, useSession = false) => {
  if (!HAS_WINDOW) return;

  const storage = _getStorage(useSession);

  try {
    const storageValue = storage.getItem(key);
    if (!storageValue) return;

    return JSON.parse(storageValue);
  } catch (e) {
    console.error(e);
  }
};
